module.exports = __webpack_public_path__ + "img/logo12.c4ad9d48.jpg";